import { memo, useState, useCallback } from 'react';
import { Share2, ChevronDown, Clock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { PublishDialogMemo } from './PublishDialog';
import { SchedulePublishDialogMemo } from './SchedulePublishDialog';
import { IPublishButtonProps } from '@/@types/publishing';

const PublishButton = ({
  postId,
  disabled = false,
  className,
  buttonText = 'Publish to Facebook',
}: IPublishButtonProps) => {
  const [publishDialogOpen, setPublishDialogOpen] = useState(false);
  const [scheduleDialogOpen, setScheduleDialogOpen] = useState(false);

  const handlePublishNow = useCallback(() => {
    setPublishDialogOpen(true);
  }, []);

  const handleSchedule = useCallback(() => {
    setScheduleDialogOpen(true);
  }, []);

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button disabled={disabled} className={className}>
            <Share2 className="w-4 h-4 mr-2" />
            {buttonText}
            <ChevronDown className="w-4 h-4 ml-2" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onClick={handlePublishNow}>
            <Share2 className="w-4 h-4 mr-2" />
            Publish Now
          </DropdownMenuItem>
          <DropdownMenuItem onClick={handleSchedule}>
            <Clock className="w-4 h-4 mr-2" />
            Schedule Publishing
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <PublishDialogMemo
        postId={postId}
        open={publishDialogOpen}
        onOpenChange={setPublishDialogOpen}
      />

      <SchedulePublishDialogMemo
        postId={postId}
        isOpen={scheduleDialogOpen}
        onClose={() => setScheduleDialogOpen(false)}
      />
    </>
  );
};

export const PublishButtonMemo = memo(PublishButton);
